import { Icon, IconProps } from '@chakra-ui/react';

export function WarningOutlinedIcon(props: IconProps): JSX.Element {
  return (
    <Icon
      width="37"
      height="32"
      viewBox="0 0 37 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.16687 32.0002L18.5002 0.333496L36.8335 32.0002H0.16687ZM5.91687 28.6668H31.0835L18.5002 7.00016L5.91687 28.6668ZM18.5002 27.0002C18.9724 27.0002 19.3683 26.8404 19.6877 26.521C20.0072 26.2015 20.1669 25.8057 20.1669 25.3335C20.1669 24.8613 20.0072 24.4654 19.6877 24.146C19.3683 23.8265 18.9724 23.6668 18.5002 23.6668C18.028 23.6668 17.6321 23.8265 17.3127 24.146C16.9933 24.4654 16.8335 24.8613 16.8335 25.3335C16.8335 25.8057 16.9933 26.2015 17.3127 26.521C17.6321 26.8404 18.028 27.0002 18.5002 27.0002ZM16.8335 22.0002H20.1669V13.6668H16.8335V22.0002Z"
        fill="url(#paint0_linear_685_575)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_685_575"
          x1="-6.65029"
          y1="16.8141"
          x2="1.21732"
          y2="-5.98654"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#844AE3" />
          <stop offset="1" stop-color="#E14AE3" />
        </linearGradient>
      </defs>
    </Icon>
  );
}
